export default __webpack_public_path__ + "static/media/skill10.f7e96801.svg";